import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, BadgeCheckIcon } from 'lucide-react';
const socialProofData = [{
  name: 'Valentina',
  city: 'Buenos Aires',
  time: '2 min',
  photo: 'https://i.pravatar.cc/80?img=1',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Diego',
  city: 'Rosario',
  time: '5 min',
  photo: 'https://i.pravatar.cc/80?img=11',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Sofía',
  city: 'CABA',
  time: '1 min',
  photo: 'https://i.pravatar.cc/80?img=5',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Martín',
  city: 'Córdoba',
  time: '8 min',
  photo: 'https://i.pravatar.cc/80?img=12',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Camila',
  city: 'Medellín',
  time: '3 min',
  photo: 'https://i.pravatar.cc/80?img=9',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Lucía',
  city: 'Santiago',
  time: '6 min',
  photo: 'https://i.pravatar.cc/80?img=16',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Rodrigo',
  city: 'Montevideo',
  time: '4 min',
  photo: 'https://i.pravatar.cc/80?img=14',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Ana',
  city: 'Bogotá',
  time: '7 min',
  photo: 'https://i.pravatar.cc/80?img=20',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Florencia',
  city: 'Mendoza',
  time: '2 min',
  photo: 'https://i.pravatar.cc/80?img=23',
  pack: 'Pack Completo + 6 Bonus'
}, {
  name: 'Matías',
  city: 'La Plata',
  time: '9 min',
  photo: 'https://i.pravatar.cc/80?img=33',
  pack: 'Pack Completo + 6 Bonus'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // Wait 12 seconds before showing the next one
      const timer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % socialProofData.length);
        setIsVisible(true);
      }, 12000);
      return () => clearTimeout(timer);
    } else {
      // Hide after 4 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  const currentData = socialProofData[currentIndex];
  return <AnimatePresence data-id="element-180">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-6 left-6 z-50 bg-white border border-gray-200 border-l-4 border-l-accent-gold rounded-xl shadow-xl p-4 max-w-[300px] pr-8" data-id="element-181">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-182">
            <XIcon className="w-4 h-4" data-id="element-183" />
          </button>

          <div className="flex items-center" data-id="element-184">
            <img src={currentData.photo} alt={currentData.name} className="w-11 h-11 rounded-full object-cover shrink-0 mr-3 border-2 border-accent-gold/40" data-id="element-185" />
            <div data-id="element-186">
              <p className="text-slate-900 text-sm font-bold leading-tight" data-id="element-187">
                {currentData.name} de {currentData.city}
              </p>
              <p className="text-accent-gold text-xs mt-0.5 font-medium" data-id="element-188">
                {currentData.pack}
              </p>
              <div className="flex items-center gap-1.5 mt-1" data-id="element-189">
                <BadgeCheckIcon className="w-3.5 h-3.5 text-accent-gold" data-id="element-190" />
                <span className="text-accent-gold text-[10px] font-semibold" data-id="element-191">
                  Compra verificada
                </span>
                <span className="text-text-secondary text-[10px]" data-id="element-192">
                  · Hace {currentData.time}
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}